<template>
  <div class="rp-page">
    <div class="rp-card">
      <div class="rp-brand">
        <div class="rp-logo">M</div>
        <div>
          <div class="rp-name">MHLM</div>
          <div class="rp-sub">Consultora SaaS</div>
        </div>
      </div>

      <h2 class="rp-title">Nueva contraseña</h2>
      <p class="rp-hint">Ingresá tu nueva contraseña (mínimo 8 caracteres).</p>

      <form @submit.prevent="submit" class="rp-form" v-if="!done">
        <div>
          <label class="fl">Email</label>
          <input class="fi" type="email" v-model="form.email" required />
        </div>
        <div>
          <label class="fl">Nueva contraseña</label>
          <input class="fi" type="password" v-model="form.password" required minlength="8" autocomplete="new-password" />
        </div>
        <div>
          <label class="fl">Confirmar contraseña</label>
          <input class="fi" type="password" v-model="form.password_confirmation" required minlength="8" autocomplete="new-password" />
        </div>
        <button class="btn btn-p btn-block" type="submit" :disabled="loading">
          {{ loading ? 'Guardando...' : 'Restablecer contraseña' }}
        </button>
        <p v-if="error" class="rp-err">{{ error }}</p>
      </form>

      <div v-else class="rp-ok">
        <p>Contraseña actualizada ✓</p>
        <router-link to="/login" class="btn btn-p btn-block">Iniciar sesión</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
export default {
  name: 'ResetPasswordView',
  data() {
    const email = this.$route?.query?.email || '';
    const token = this.$route?.query?.token || '';
    return {
      form: { email, token, password: '', password_confirmation: '' },
      loading: false, error: '', done: false
    };
  },
  methods: {
    async submit() {
      this.error = ''; this.loading = true;
      try {
        await api.post('/password/reset', this.form);
        this.done = true;
      } catch (e) {
        const resp = e?.response?.data;
        this.error = resp?.errors?.password?.[0] || resp?.message || 'No se pudo restablecer la contraseña.';
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.rp-page{ position:fixed; inset:0; display:grid; place-items:center; padding:24px; background:var(--bg); }
.rp-card{
  width:100%; max-width:420px; padding:28px 26px;
  background:var(--surface); border:1px solid var(--border); border-radius:12px;
  box-shadow:0 10px 40px rgba(3,43,82,.1);
}
.rp-brand{ display:flex; align-items:center; gap:12px; margin-bottom:18px; }
.rp-logo{
  width:42px; height:42px; border-radius:10px;
  background:var(--mhlm-grad); color:#fff;
  display:flex; align-items:center; justify-content:center;
  font-size:22px; font-weight:900;
  box-shadow:0 4px 12px rgba(21,96,189,.25);
}
.rp-name{ font-size:20px; font-weight:800; letter-spacing:.12em; color:var(--mhlm-navy); }
.rp-sub{ font-size:9px; letter-spacing:.3em; text-transform:uppercase; color:var(--tx-md); margin-top:2px; }
.rp-title{ font-size:20px; font-weight:700; color:var(--tx-hi); margin:0 0 6px; }
.rp-hint{ font-size:13px; color:var(--tx-md); margin:0 0 18px; }
.rp-form{ display:grid; gap:12px; }
.rp-err{ margin:8px 0 0; padding:9px 12px; border-radius:8px; background:var(--mhlm-pastel-rose); color:#8a2a2a; font-size:12.5px; }
.rp-ok{ text-align:center; display:grid; gap:14px; }
.rp-ok p{ font-size:18px; color:#2E9E67; font-weight:600; }
</style>
